<div *ngIf="control && control.invalid && (control.dirty || control.touched)">
  <div
    *ngIf="control.errors?.['required'] || control.errors?.['requiredTrue']"
    class="invalid-feedback"
  >
    <div *ngIf="label && label.length < 18">{{ effectiveLabel }} is een vereist veld.</div>
    <div *ngIf="!label || label.length >= 18">Dit is een vereist veld.</div>
  </div>
  <div *ngIf="control.errors?.['max']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} mag maximaal {{ control.errors?.["max"].max }} zijn.
  </div>
  <div *ngIf="control.errors?.['min']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} moet minimaal {{ control.errors?.["min"].min }} zijn.
  </div>
  <div *ngIf="control.errors?.['minlength']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} moet minimaal
    {{ control.errors?.["minlength"].requiredLength }} tekens bevatten.
  </div>
  <div *ngIf="control.errors?.['maxlength']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} mag maximaal
    {{ control.errors?.["maxlength"].requiredLength }} tekens bevatten.
  </div>
  <div *ngIf="control.errors?.['minArrayLength']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} moet minimaal
    {{ control.errors?.["minlength"].requiredLength }} elementen bevatten.
  </div>
  <div *ngIf="control.errors?.['maxArrayLength']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} mag maximaal
    {{ control.errors?.["maxlength"].requiredLength }} elementen bevatten.
  </div>
  <div *ngIf="control.errors?.['invalidEmail']" class="invalid-feedback">Ongeldig e-mailadres.</div>
  <div *ngIf="control.errors?.['iban']" class="invalid-feedback">Ongeldig IBAN-nummer.<br>Gebruik het formaat BE71 0961 2345 6769 (zonder punten of streepjes).</div>
  <div *ngIf="control.errors?.['gln']" class="invalid-feedback">Ongeldig GLN-nummer. Een GLN bestaat uit exact 13 cijfers met een geldig controlecijfer.</div>
  <div *ngIf="control.errors?.['exists']" class="invalid-feedback">Deze waarde bestaat al.</div>
  <div *ngIf="control.errors?.['invalidUrl']" class="invalid-feedback">Ongeldige website</div>
  <div *ngIf="control.errors?.['dateCompare']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} moet {{ control.errors?.["dateCompare"][0] }}
    {{ control.errors?.["dateCompare"][1] }} {{ control.errors?.["dateCompare"][2] }} liggen
  </div>
  <div *ngIf="control.errors?.['invalidFormat']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} mag enkel
    {{ control.errors?.["invalidFormat"].allowedCharacters }} bevatten
  </div>
  <div *ngIf="control.errors?.['isNotInPreviousYear']" class="invalid-feedback">
    {{ effectiveLabel ?? defaultLabel }} moet in {{ currentYear.getFullYear() - 1 }} zijn
  </div>
  <div *ngIf="control.errors?.['maxDayExpense']" class="invalid-feedback">
    Deze vergoeding overschrijdt de maximum toegelaten forfaitaire dagvergoeding van €{{
      ExpenseDayMax
    }}
    in België met €{{ control.errors?.["maxDayExpense"] | number: "1.2-2" }}
  </div>
  <div *ngIf="control.errors?.['maxYearExpense']" class="invalid-feedback">
    Deze vergoeding overschrijdt de maximum toegelaten
    @if (control.errors?.["maxYearExpense"].increased) {
      verhoogde
    }
    forfaitaire jaarvergoeding van €{{
      control.errors?.["maxYearExpense"].increased ? IncreasedYearMax : YearMax
    }}
    in België met €{{ control.errors?.["maxYearExpense"].amount | number: "1.2-2" }}
  </div>
</div>
<div *ngIf="control && control.invalid && (control.dirty || control.touched)">
  <div *ngIf="type" class="invalid-feedback">
    {{ text }}
    <ng-content></ng-content>
  </div>
</div>
